
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/reactjs-for-kids",
      function () {
        return require("private-next-pages/courses/reactjs-for-kids.tsx");
      }
    ]);
  